import {
  Button, Dialog, DialogActions, DialogContent,
  DialogContentText, DialogTitle, Typography, makeStyles,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Form } from 'react-final-form';
import { useContext } from "react";

import QCXSelectDespachanteAutocomplete from '../../../../shared-components/select-despachante/QCXSelectDespachanteAutocomplete';
import DeclaracaoImportacaoContext from '../../../../contexts/import/declaracao-importacao/DeclaracaoImportacaoContext';


const useStyles = makeStyles({
  paper: {
      maxWidth: '50%',
      width: 800,
      padding: '24px 32px',
      '@media (max-width: 900px)': {
          maxWidth: '100%',
          width: '100%',
          padding: '16px',
      },
  },
  header: {
    margin: '-24px -32px 24px -32px',
    padding: '20px 32px',
    backgroundColor: '#f9fafb',
    borderBottom: '1px solid #e5e7eb',
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    color: '#111827',
  },
  subtitle: {
    fontSize: 14,
    color: '#6b7280',
    marginTop: 4,
  },
});

export default function SelectDespachanteModal({ isModalOpen, setIsModalOpen, title, buttonTitle, children, onConfirm, disabled, isDuimp = false, authInfo = {}, onChange }) {

  const { t } = useTranslation();
  const classes = useStyles();

  const fechar = t('com.muralis.qcx.acoes.fechar');
  const titleConfirmButon = "Selecionar";
  const modalTile = "Selecionar Despachante";

  const {
    handleTransmissaoDuimp,
    duimpSelecionadaTransmissao,
    setExibirModalDespachante,
  } = useContext(DeclaracaoImportacaoContext);

  const transmitirDuimp = (despachante) => {
    console.log("despachante selecionado: ", {...duimpSelecionadaTransmissao, ...despachante});
    handleTransmissaoDuimp({...duimpSelecionadaTransmissao, ...despachante});
    setExibirModalDespachante(false)
  }

  return (
    <Dialog
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        classes={{ paper: classes.paper }}
    >
        <div className={classes.header}>
          <Typography className={classes.title}>
            Selecionar despachante
          </Typography>
          <Typography className={classes.subtitle}>
            Escolha o despachante que será utilizado na transmissão da DUIMP
          </Typography>
        </div>

        <DialogContent style={{ paddingTop: 8 }}>
            <div>
              <Form  onSubmit={transmitirDuimp}>
                {({ handleSubmit }) => (
                  <form id="transmissao-form" onSubmit={handleSubmit}>
                    <QCXSelectDespachanteAutocomplete
                      label="Despachante"
                      name="despachante"
                      required
                      disabled={false}
                    />
                  </form>
                )}
              </Form>
            </div>
        </DialogContent>
        <DialogActions>

            <Button variant="outlined" onClick={() => setIsModalOpen(false)} color="secondary">
                {fechar}
            </Button>

            <Button 
                variant="contained"
                type="submit"
                form="transmissao-form"
                title={titleConfirmButon}
                color="primary"
                disabled={disabled}
              >
                {titleConfirmButon}
            </Button>

        </DialogActions>
    </Dialog>
  )
}
